import React from 'react'
import PropTypes from 'prop-types'
import BlockStyleControls from './BlockStyleControls'
import AddImageButton from './AddImageButton'
import EmailTemplateButton from './EmailTemplateButton'
import ResetEditorButton from './ResetEditorButton'
import css from './styles.css'

const StyleControls = ({
  toggleBlockType,
  editorState,
  updateParentBodyState,
  modifier,
  isMessageSetting,
  isBlastEmail,
  openCreateTemplateModal,
  createModalOpen,
  handleTemplateSelection,
  hideImgPicker,
  openOptionsModal,
  optionsModalOpen,
  closeOptionsModal,
  templateSettings,
  isEmail,
  showExtraButtons,
}) => {
  return (
    <div className={css.wrapper}>
      <BlockStyleControls
        onToggle={toggleBlockType}
        editorState={editorState}
      />
      <AddImageButton
        editorState={editorState}
        onChange={updateParentBodyState}
        modifier={modifier}
      />
      {!isMessageSetting && !isBlastEmail && (
        <EmailTemplateButton
          openCreateTemplateModal={openCreateTemplateModal}
          createModalOpen={createModalOpen}
          handleTemplateSelection={handleTemplateSelection}
          hideImgPicker={hideImgPicker}
          openOptionsModal={openOptionsModal}
          optionsModalOpen={optionsModalOpen}
          closeOptionsModal={closeOptionsModal}
          templateSettings={templateSettings}
          isEmail={isEmail}
        />
      )}
      {!showExtraButtons
        ? null
        : [
            <ResetEditorButton
              key="reseteditor"
              updateParentBodyState={updateParentBodyState}
            />,
          ]}
    </div>
  )
}

StyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  toggleBlockType: PropTypes.func.isRequired,
  updateParentBodyState: PropTypes.func.isRequired,
  modifier: PropTypes.func.isRequired,
  hideImgPicker: PropTypes.bool,
  isEmail: PropTypes.bool,
  showExtraButtons: PropTypes.bool,
  openOptionsModal: PropTypes.func,
  optionsModalOpen: PropTypes.bool,
  closeOptionsModal: PropTypes.func,
  templateSettings: PropTypes.array,
}

StyleControls.defaultProps = {
  showExtraButtons: false,
}

export default StyleControls



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/index.js